import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Contact from '../../contact/contact';

const ContactBlock = ({ paddingTop, paddingBottom, ...props }) => {
  return (
    <Container gutters>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Contact {...props} />
      </Spacing>
    </Container>
  );
};

export default ContactBlock;

export const query = graphql`
  fragment ContactBlock on DatoCmsContactBlock {
    id: originalId
    paddingBottom
    paddingTop
    personName
    personEmail
    personPhone
    personTitle
    linkedinUrl
    formTitle
    personImage {
        gatsbyImageData(imgixParams: { fit: "fill", w: "402", h: "525" })
        alt
    }
    __typename
  }
`;
